import { useCallback, useEffect, useState } from "react";
import { Button, Modal, OverlayTrigger, Pagination, Table, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp, faCircleCheck, faEye, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { BsExclamationTriangleFill } from "react-icons/bs";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import useAuth from "../../../Pages/hooks/useAuth";
import { APROVE, baseURL, MONEY, REJECT } from "../../../API/API";
import { resolveMediaUrl } from "../../../utils/mediaUrl";
import "./Content.css";

export default function Money() {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const [rows, setRows] = useState([]);
  const [Order, setOrder] = useState("created_at");
  const [OrderType, setOrderType] = useState(true);
  const [TypeStudent] = useState("pending");
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showReject, setShowReject] = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [screenshot, setScreenshot] = useState(null);

  let role = auth?.user?.role;
  if (!role || role === "student") {
    if (auth?.user?.email === "admin@academy.com" || auth?.user?.email === "admin@example.com") role = "admin";
    else if (auth?.user?.is_staff) role = "teacher";
    else role = "student";
  }
  const isAdmin = role === "admin";

  const fetchData = useCallback(async () => {
    try {
      const res = await axiosPrivate.post(`${baseURL}/${MONEY}`, {
        Order,
        OrderType,
        Typestudent: TypeStudent,
        indexpage,
      });
      setRows(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error("Error loading payment requests:", err);
      setRows([]);
      toast.error(err.response?.data?.message || "فشل تحميل التحويلات");
    }
  }, [axiosPrivate, Order, OrderType, TypeStudent, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const sortBy = (column, desc) => {
    setOrder(column);
    setOrderType(desc);
  };

  const openReceipt = (path) => {
    const resolved = resolveMediaUrl(path);
    if (!resolved) {
      toast.error("لا توجد صورة وصل لهذا الطلب");
      return;
    }
    setScreenshot(resolved);
    setShowImage(true);
  };

  const approveRequest = async () => {
    try {
      await axiosPrivate.post(`${baseURL}/${APROVE}`, { id: selectedId });
      toast.success("تم قبول الدفعة وفتح المحتوى المطلوب");
      setShowApprove(false);
      setSelectedId(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.message || "حدث خطأ أثناء قبول الدفع");
    }
  };

  const rejectRequest = async () => {
    try {
      await axiosPrivate.post(`${baseURL}/${REJECT}`, { id: selectedId });
      toast.success("تم رفض الطلب");
      setShowReject(false);
      setSelectedId(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.message || "حدث خطأ أثناء رفض الدفع");
    }
  };

  const SortHeader = ({ label, column }) => (
    <div className="d-flex align-items-center justify-content-center gap-2">
      <span>{label}</span>
      <span className="d-flex flex-column" style={{ fontSize: 12, cursor: "pointer" }}>
        <FontAwesomeIcon onClick={() => sortBy(column, true)} icon={faCaretUp} />
        <FontAwesomeIcon onClick={() => sortBy(column, false)} icon={faCaretDown} />
      </span>
    </div>
  );

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center mb-5">
        <h4 className="fw-bold">التحويلات</h4>
      </div>

      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              <th><SortHeader label="الاسم" column="username" /></th>
              <th><SortHeader label="طريقة الدفع" column="method" /></th>
              <th><SortHeader label="المبلغ" column="amount" /></th>
              {isAdmin && <th>المعلم المحول إليه</th>}
              {isAdmin && <th>الباقة/الاشتراك</th>}
              <th>الوصل</th>
              <th>أدوات</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={isAdmin ? 7 : 5} className="text-muted py-4">لا توجد تحويلات حالية.</td></tr>
            ) : rows.map((row) => (
              <tr key={row.id}>
                <td>{row.username}</td>
                <td>{row.method}</td>
                <td className="fw-bold">{Number(row.amount || 0).toFixed(0)} ج.م</td>
                {isAdmin && <td>{row.teacher_name || "الأدمن الأساسي"}</td>}
                {isAdmin && <td><div className="fw-bold">{row.package_name || "شحن رصيد"}</div><div className="small text-muted">{row.package_type}</div></td>}
                <td>
                  {row.screenshot ? (
                    <img src={resolveMediaUrl(row.screenshot)} alt="وصل الدفع" style={{ width: 54, height: 54, objectFit: "cover", cursor: "pointer", borderRadius: 6, border: "1px solid #ddd" }} onClick={() => openReceipt(row.screenshot)} />
                  ) : <span className="text-muted small">لا يوجد</span>}
                </td>
                <td>
                  <div className="d-flex justify-content-center gap-2">
                    <OverlayTrigger placement="top" overlay={<Tooltip>عرض الوصل</Tooltip>}>
                      <Button onClick={() => openReceipt(row.screenshot)} size="sm" variant="outline-info"><FontAwesomeIcon icon={faEye} /></Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>قبول</Tooltip>}>
                      <Button onClick={() => { setSelectedId(row.id); setShowApprove(true); }} size="sm" variant="outline-success"><FontAwesomeIcon icon={faCircleCheck} /></Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>رفض</Tooltip>}>
                      <Button onClick={() => { setSelectedId(row.id); setShowReject(true); }} size="sm" variant="outline-danger"><FontAwesomeIcon icon={faMinusCircle} /></Button>
                    </OverlayTrigger>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <Pagination className="justify-content-center custom-pagination" dir="ltr">
        <Pagination.Prev onClick={() => indexpage > 1 && setindexPage(indexpage - 1)} disabled={indexpage === 1} />
        {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
          <Pagination.Item key={page} active={indexpage === page} onClick={() => setindexPage(page)}>{page}</Pagination.Item>
        ))}
        <Pagination.Next onClick={() => indexpage < totalPages && setindexPage(indexpage + 1)} disabled={indexpage === totalPages} />
      </Pagination>

      <Modal show={showImage} onHide={() => setShowImage(false)} centered size="lg" dir="rtl">
        <Modal.Header closeButton><Modal.Title>صورة الوصل</Modal.Title></Modal.Header>
        <Modal.Body className="text-center">
          {screenshot && <img src={screenshot} alt="وصل الدفع" style={{ maxWidth: "100%", maxHeight: "75vh", objectFit: "contain" }} />}
        </Modal.Body>
      </Modal>

      {showReject && <ConfirmModal title="هل تريد رفض هذه الدفعة؟" body="سيتم رفض الدفع ولن يتم فتح أي محتوى للطالب." onCancel={() => setShowReject(false)} onConfirm={rejectRequest} />}
      {showApprove && <ConfirmModal title="هل تريد قبول هذه الدفعة؟" body="سيتم اعتماد الدفع وفتح محتوى الباقة أو الكومبو تلقائيا عند وجوده." onCancel={() => setShowApprove(false)} onConfirm={approveRequest} />}
    </div>
  );
}

function ConfirmModal({ title, body, onCancel, onConfirm }) {
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-content">
        <h2><BsExclamationTriangleFill className="text-warning fs-1 me-2" />{title}</h2>
        <p>{body}</p>
        <div className="d-flex justify-content-start gap-3">
          <button className="btn btn-outline-danger mt-3" onClick={onConfirm}>تأكيد</button>
          <button className="btn btn-outline-secondary mt-3" onClick={onCancel}>إغلاق</button>
        </div>
      </div>
    </div>
  );
}